import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '@/lib/auth';
import useDocumentMeta from '@/lib/useDocumentMeta';
import BrandMark from '@/components/BrandMark';

export default function AdminLogin() {
    useDocumentMeta({ title: 'Admin · Maison Touré' });
    const nav = useNavigate();
    const [form, setForm] = useState({ email: '', password: '' });
    const [err, setErr] = useState('');
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr(''); setBusy(true);
        try {
            await login(form.email.trim().toLowerCase(), form.password);
            nav('/admin', { replace: true });
        } catch (e2) {
            const d = e2.response?.data?.detail;
            setErr(typeof d === 'string' ? d : 'Invalid credentials.');
        } finally { setBusy(false); }
    };

    return (
        <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center" style={{ background: 'var(--paper)' }}>
            <div className="w-full max-w-md px-6 md:px-10">
                <div className="text-center flex flex-col items-center">
                    <BrandMark variant="dark" size={56} wordmarkSize={30} showSubline={false} />
                    <div className="wordmark-sub mt-2">Admin · Private</div>
                </div>
                <form onSubmit={submit} className="mt-16 flex flex-col gap-8" data-testid="admin-login-form">
                    <span className="section-no">§ Sign in</span>
                    <h1 className="serif text-4xl md:text-5xl leading-[1]">Curator's desk</h1>
                    <input data-testid="login-email" type="email" required placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="input-line" />
                    <input data-testid="login-password" type="password" required placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="input-line" />
                    {err && <p data-testid="login-error" className="caption" style={{ color: 'var(--clay-deep)' }}>{err}</p>}
                    <button data-testid="login-submit" disabled={busy} className="btn-primary self-start mt-4">{busy ? 'Signing in…' : 'Sign in'}</button>
                </form>
            </div>
        </div>
    );
}
